import ReportServices from "@/services/ReportServices.js";

export default {
  getBestSellingItems: ReportServices.getBestSellingItems
}